












import Vue from "vue";

import { computed } from "@vue/composition-api";
import NavBarButton from "../NavBarButton.vue";
import { NotificationsManager } from "./NotificationManager";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: { NavBarButton },
  props: ["isOpen"],
  setup() {
    const {
      notifications,
      shouldRunMoreTasks: showLoader,
    } = NotificationsManager;
    const jobCount = computed(() => notifications.value.length);

    return {
      showLoader,
      jobCount,
      theme: SharedState.theme,
    };
  },
});
